import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { routes } from '../../../routes';

const RouteLoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      minHeight: '200px',
    }}
  />
);

export const Router: React.FC<React.PropsWithChildren> = () => {
  return (
    <Suspense fallback={<RouteLoadingFallback />}>
      <Routes>
        {routes.map((route) => {
          let children = null;

          if (route.children) {
            children = route.children.map((child) => (
              <Route
                key={child.path}
                path={child.path}
                element={child.element}
              />
            ));
          }

          if (children) {
            return (
              <Route key={route.path} path={route.path} element={route.element}>
                {children}
              </Route>
            );
          }
          return (
            <Route key={route.path} path={route.path} element={route.element} />
          );
        })}
      </Routes>
    </Suspense>
  );
};
